import { defineStore } from 'pinia'
import { fetchUserInfo as fetchUserInfoApi, type UserInfo } from '@/api/userApi'
import { logout as logoutApi } from '@/api/userApi'

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: null as UserInfo | null,
  }),
  actions: {
    /**
     * APIからUserInfoを取得してstateとSessionStorageに保存
     */
    async fetchUserInfo() {
      const data = await fetchUserInfoApi()
      this.userInfo = data
      // SessionStorageにも保存
      sessionStorage.setItem('user_info', JSON.stringify(data))
    },

    /**
     * ログアウトなどで情報をクリア
     */
    clearUserInfo() {
      this.userInfo = null
      sessionStorage.removeItem('user_info')
    },

    async logout() {
      try {
        await logoutApi()
      } finally {
        this.clearUserInfo()
      }
    },
  },
})
